export const ADDRESS = {
    street_number: 'Huisnummer',
    route: 'Straatnaam',
    postal_code: 'Postcode',
    locality: 'Plaats',
    province: 'Provincie',
    country: 'Land'
}

export const getAddressDataset = (field_id: any) => Object.keys(ADDRESS).map(i => ({ label: ADDRESS[i], value: `${field_id}+${i}` }));